import apiCall from '@/utils/api'

const state = {
    promotions: [],
    promotionPagination: {
        current_page: 1,
        per_page: 0,
        total: 0,
        visible: 10
    },
    promotionFormData: {
        levels: [],
        sub_levels: []
    },
    studentsInClass: [],
    alumni: [],
    alumniPagination: {
        current_page: 1,
        per_page: 0,
        total: 0,
        visible: 10
    },
    promotionPreview: null,
    promotionLoader: false
};

const getters = {
    promotionLoader: (state) => state.promotionLoader,
    promotions: (state) => state.promotions,
    promotionPagination: (state) => state.promotionPagination,
    promotionFormData: (state) => state.promotionFormData,
    studentsInClass: (state) => state.studentsInClass,
    alumni: (state) => state.alumni,
    alumniPagination: (state) => state.alumniPagination,
    promotionPreview: (state) => state.promotionPreview,
}

const actions = {
    async fetchPromotions({ commit }, page) {
        const response = await apiCall({ url: `/api/student-promotion?page=${page}`, method: 'GET' });
        commit('setPromotions', response)
        commit('stopPromotionLoader')
    },
    async fetchPromotionFormData({ commit }) {
        const response = await apiCall({ url: `/api/student-promotion?type=formData`, method: 'GET' });
        commit('setPromotionFormData', response)
    },
    async fetchStudentsInClass({ commit }, subLevelId) {
        const response = await apiCall({ url: `/api/student-promotion?type=studentsInClass&sub_level_id=${subLevelId}`, method: 'GET' });
        commit('setStudentsInClass', response)
    },
    async fetchAlumni({ commit }, { page, search }) {
        let url = `/api/student-promotion?type=alumni&page=${page}`
        if (search) {
            url += `&search=${search}`
        }
        const response = await apiCall({ url, method: 'GET' });
        commit('setAlumni', response)
        commit('stopPromotionLoader')
    },
    async fetchPromotionPreview({ commit }, subLevelId) {
        let url = `/api/student-promotion?type=preview`
        if (subLevelId) {
            url += `&from_sub_level_id=${subLevelId}`
        }
        const response = await apiCall({ url, method: 'POST' });
        commit('setPromotionPreview', response)
    },
    async promoteSingleStudent({ commit }, data) {
        const response = await apiCall({
            url: `/api/student-promotion?type=single`,
            method: 'POST',
            data
        });
        return response
    },
    async promoteBulkStudents({ commit }, data) {
        const response = await apiCall({
            url: `/api/student-promotion?type=bulk`,
            method: 'POST',
            data
        });
        return response
    },
    async promoteEntireClass({ commit }, data) {
        const response = await apiCall({
            url: `/api/student-promotion?type=class`,
            method: 'POST',
            data
        });
        return response
    },
    async revertPromotion({ commit }, promotionId) {
        const response = await apiCall({
            url: `/api/student-promotion/revert`,
            method: 'POST',
            data: { promotion_id: promotionId }
        });
        return response
    },
    async bulkRevertPromotions({ commit }, promotionIds) {
        const response = await apiCall({
            url: `/api/student-promotion/bulk-revert`,
            method: 'POST',
            data: { promotion_ids: promotionIds }
        });
        return response
    },
    async startPromotionLoader({ commit }) {
        commit('startPromotionLoader')
    },
    async stopPromotionLoader({ commit }) {
        commit('stopPromotionLoader')
    },
    async clearStudentsInClass({ commit }) {
        commit('clearStudentsInClass')
    },
    async clearPromotionPreview({ commit }) {
        commit('clearPromotionPreview')
    },
};

const mutations = {
    setPromotions: (state, promotions) => {
        state.promotions = promotions.data
        state.promotionPagination.current_page = promotions.current_page
        state.promotionPagination.total = promotions.total
        state.promotionPagination.per_page = promotions.per_page
    },
    setPromotionFormData: (state, formData) => {
        state.promotionFormData = formData
    },
    setStudentsInClass: (state, students) => {
        state.studentsInClass = students
    },
    clearStudentsInClass: (state) => {
        state.studentsInClass = []
    },
    setAlumni: (state, alumni) => {
        state.alumni = alumni.data
        state.alumniPagination.current_page = alumni.current_page
        state.alumniPagination.total = alumni.total
        state.alumniPagination.per_page = alumni.per_page
    },
    setPromotionPreview: (state, preview) => {
        state.promotionPreview = preview
    },
    clearPromotionPreview: (state) => {
        state.promotionPreview = null
    },
    startPromotionLoader: (state) => state.promotionLoader = true,
    stopPromotionLoader: (state) => state.promotionLoader = false,
};

export default {
    state,
    getters,
    actions,
    mutations
}
